import { createChildPath } from '../../../utils';
import generateAsyncRouteComponent from '../../../generateAsyncRouteComponent';

export default {
  path: createChildPath('orders-and-returns'),
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/OrdersAndReturnsAuthenticated'),
  }),
};
